import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import CardsBrowser from "@/components/CardsBrowser";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <CardsBrowser />
      <FAQ />
      <Footer />
    </div>
  );
};

export default Index;
